<template>
  <div class="app-balance-info">
    <slot name="txtBefore"><h2>Mein Guthaben</h2></slot>
    <span class="app-balance-info-formatted-balance">{{formattedBalance}}</span>
    <slot name="txtAfter"></slot>
    <b-overlay v-if="showButton && !hasSufficientCredit" class="btn-next-overlay" spinner-small>
      <slot  name="btnTopupCredit" >Guthaben aufladen</slot>
    </b-overlay>
  </div>
</template>

<script>
import price from '@/mixins/price'

export default {
  name: 'BalanceInfo',
  props: {
    balance: {
      type: Number,
      default: null
    },
    showButton: {
      type: Boolean,
      default: false
    },
    optionPrice: {
      type: Number,
      default: 0
    }
  },
  mixins: [
    price
  ],
  computed: {
    formattedBalance () {
      if (this.balance === null) {
        return '-'
      }
      return this.price(this.balance)
    },
    hasSufficientCredit: function () {
      return this.balance > this.optionPrice
    }
  }
}
</script>
